import {
  CognitoUserSession,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken,
} from "amazon-cognito-identity-js"
import { useEffect } from "react"
import { toast } from "sonner"
import { TOP_DOMAIN } from "../../SessionManagement/constants"
import { makeUnauthGetRequest } from "../../../utils/lambda/unauthRequests"

export default ({ history, cookies }) => {
  useEffect(() => {
    /**
     * state search param contains redirect uri after ","
     * logic below splits on ","
     * removes redirect uri from state param for /sso/auth request
     * extracts redirect uri for refer redirection
     */
    const query = new URLSearchParams(history.location.search)
    const stateParam = query.get("state").split(",")[0]
    const referURL = query.get("state").split(",")[1]
    query.set("state", stateParam)

    makeUnauthGetRequest({
      url: `/iam_v1/sso/auth?${query.toString()}`,
      onSuccess: (data) => {
        const { id_token, access_token, refresh_token } = data
        const Session = new CognitoUserSession({
          IdToken: new CognitoIdToken({ IdToken: id_token }),
          AccessToken: new CognitoAccessToken({ AccessToken: access_token }),
          RefreshToken: new CognitoRefreshToken({
            RefreshToken: refresh_token,
          }),
        })

        const {
          clockDrift,
          idToken: {
            jwtToken: idToken,
            payload: { aud: client_id, sub: user_id, email, iss },
          },
          accessToken: { jwtToken: accessToken },
          refreshToken: { token: refreshToken },
        } = Session
        const user_pool_id = iss.split("/").pop()
        const hostDomain = window.location.host.split(":").shift()
        const hostDomainObject = { domain: `.${hostDomain}`, path: "/" }

        cookies.set("ApplicationClientId", client_id, { path: "/" })
        cookies.set("UserPool", user_pool_id, { path: "/" })
        cookies.set(
          `CognitoIdentityServiceProvider.${client_id}.LastAuthUser`,
          user_id,
          hostDomainObject
        )
        cookies.set(`CognitoIdentityServiceProvider.USER_EMAIL`, email, {
          domain: TOP_DOMAIN,
          path: "/",
        })
        cookies.set(
          `CognitoIdentityServiceProvider.${client_id}.${user_id}.clockDrift`,
          clockDrift,
          hostDomainObject
        )
        cookies.set(
          `CognitoIdentityServiceProvider.${client_id}.${user_id}.accessToken`,
          accessToken,
          hostDomainObject
        )
        cookies.set(
          `CognitoIdentityServiceProvider.${client_id}.${user_id}.idToken`,
          idToken,
          hostDomainObject
        )
        cookies.set(
          `CognitoIdentityServiceProvider.${client_id}.${user_id}.refreshToken`,
          refreshToken,
          hostDomainObject
        )
        history.push(referURL || "/home")
      },
      onFailure: () => {
        history.push(`/sso/login${referURL ? `?refer=${referURL}` : ""}`)
        toast.error("Unable to login user, please try again")
      },
    })
  }, [])
  return null
}
